import React, { Component } from 'react';
import { useHeadlessCheckoutContext } from '@/context/HeadlessCheckoutContext';
import AddressValidationModal from './AddressValidationModal';

// Error boundary to prevent validation issues from breaking the checkout flow
class AddressValidationErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Address validation error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // If there's an error, just don't render the validation modal
      // This allows the checkout to continue without validation if necessary
      return null;
    }

    return this.props.children;
  }
}

const AddressValidationModalContainer = () => {
  const { 
    addressValidationModalOpen, 
    setAddressValidationModalOpen, 
    addressToValidate, 
    validationDetails,
    submitValidatedAddress,
    setDisplayNotificationError,
    setNotificationMessage,
    isAddressValidating,
    setAddressToValidate,
    setValidationDetails,
  } = useHeadlessCheckoutContext();

  // We no longer need to validate errors here or close automatically
  // because we will only validate when the user clicks save

  const handleClose = () => {
    // When the user cancels, just close the modal without saving the address
    setAddressValidationModalOpen(false);
    
    // Set a specific message for the notification
    if (setNotificationMessage) {
      setNotificationMessage("Address validation was cancelled. Your address was not saved.");
    }
    
    // Show a notification to inform the user that the address was not saved
    setDisplayNotificationError(true);
    
    // Reset validation state
    setAddressToValidate(null);
    setValidationDetails(null);
    
    console.warn('User cancelled address validation - address not saved to Shopify');
  };

  // Only show the modal if it's open and we have an address to validate
  if (!addressValidationModalOpen || !addressToValidate) {
    return null;
  }

  return (
    <AddressValidationErrorBoundary>
      <AddressValidationModal
        open={addressValidationModalOpen}
        onClose={handleClose}
        address={addressToValidate}
        validationDetails={validationDetails || { errors: [] }}
        onSubmit={submitValidatedAddress}
        isValidating={isAddressValidating}
      />
    </AddressValidationErrorBoundary>
  );
};

export default AddressValidationModalContainer; 